import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { FirebaseProvider } from './lib/firebase/FirebaseProvider'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import SubmitReportPage from './pages/SubmitReportPage'
import ReportDetailPage from './pages/ReportDetailPage'
import TreasuresPage from './pages/TreasuresPage'
import ProfilePage from './pages/ProfilePage'
import GuidelinesPage from './pages/GuidelinesPage'
import { AdminPage } from './pages/AdminPage'
import { AdvancedSearchPage } from './pages/AdvancedSearchPage'
import { PremiumFeaturesPage } from './pages/PremiumFeaturesPage'
import { initializeMobileOptimizations } from './utils/mobileOptimizations'
import './App.css'

function App() {
  useEffect(() => {
    // Initialize mobile optimizations
    const cleanup = initializeMobileOptimizations();
    
    return cleanup;
  }, []);

  return (
    <FirebaseProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="submit" element={<SubmitReportPage />} />
            {/* Redirect legacy routes to unified treasures page */}
            <Route path="reports" element={<Navigate to="/treasures" replace />} />
            <Route path="map" element={<Navigate to="/treasures" replace />} />
            <Route path="reports/:id" element={<ReportDetailPage />} />
            <Route path="treasures/:id" element={<ReportDetailPage />} />
            <Route path="treasures" element={<TreasuresPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="admin" element={<AdminPage />} />
            <Route path="advanced-search" element={<AdvancedSearchPage />} />
            <Route path="premium" element={<PremiumFeaturesPage />} />
            <Route path="guidelines" element={<GuidelinesPage />} />
            {/* Additional routes will be added in later tasks */}
          </Route>
        </Routes>
      </div>
    </FirebaseProvider>
  )
}

export default App